import React, { Component } from "react";

export class OpenRouteModel extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    window.OpenRouteModel = this;
  }
  render() {
    let { props } = this;
    let {
      id,
      className,
      title,
      onClose,
      modalSize,
      modaltype,
      footer,
      okText,
    } = props;
    let attrs = Object.except(props, ["id", "title", "type", "onClose"]);

    return (
      <AppModalBs
        id={id}
        className={className}
        title={title}
        onClose={onClose}
        modalSize={modalSize}
        footer={footer}
        okText={okText}
      >
        <div>
          <p>
            WEALTH AVENUE CONSULTANCY SERVICES PVT LTD(”Wealth Avenue”, ”we”,
            “our” or “us”) values the users (“you”, “your” or “user”) of our
            website (www.wealthavenue.in) or our mobile application(s)
            (hereafter collectively referred to as “Website”) and is committed
            to protecting your privacy and personal information. We understand
            that you may be concerned about the collection, use, and disclosure
            of the personally identifiable information (“Personal Information”)
            supplied by you during the course of usage of our website and the
            services offered therein. This Privacy Policy describes the
            information that we collect from you, how we collect this
            information, and what we do with it after we collect it. By using
            the Website or by providing us your information, you agree to be
            bound by the practices described in this Privacy Policy, and also
            give consent to the use of your Personal Information by WEALTH
            AVENUE in accordance with the terms set out in this Privacy Policy.
            ‘Personal information’ for purposes of this Policy means information
            that identifies you, such as your name, address, phone number or
            email address etc.If you have any questions or comments regarding
            this Privacy Policy, please email us at admin@wealthavenue.in
          </p>
          <p>
            This Privacy Policy is to be read with, and is an integral part of,
            our Terms of Use available at Terms unless otherwise defined in this
            Privacy Policy, terms used in this Privacy Policy have the same
            meanings as in our Terms of Use.
          </p>

          <ul>
            <p className="para_heading">1. THE APP AND CLIENTS</p>
            <p>
              Company has developed and solely owns mobile personal finance
              software applications called “WEALTH AVENUE CONSULTANCY SERVICES
              PVT LTD”,” Wealth Avenue Consultant”, “Wealth Avenue Console”,
              “Wealth Avenue Customer” (“App”, which expression shall include
              future releases of the App). Company makes the App available for
              download and use on mobile phones to clients (“Clients”).
              Downloading and installing the App shall be deemed to constitute
              sufficient proof that Clients have read, understood and accepted
              this, Policy.
            </p>
            <p className="para_heading">2. PERSONAL INFORMATION</p>
            <p>
              “Personal Information” means the Transaction Information as
              defined in the Terms of Service and includes information that is
              contained in text messages (that is, SMS) sent by providers of
              services and/or products (including but not limited to financial
              institutions, mobile carriers and utility companies) to Clients’
              mobile telephone number(s) in connection with one or more
              transactions across multiple financial accounts (including
              purchase, payments, billing information and service notifications
              related thereto). Without limitation, Transaction Information
              includes: Mobile phone numbers of Clients Email addresses of
              Clients Partial payment card data only to the extent such card
              data is disclosed in the said messages Information related to the
              transaction in question including identity of the service or
              product and the price or fee paid or payable in respect thereof.
            </p>
            <p className="para_heading">
              3. PURPOSE OF COLLECTION AND USE OF PERSONAL INFORMATION{" "}
            </p>
            <p>
              {" "}
              Company may collect, store, access and use Personal Information
              solely to the extent required for Company to enable Clients to
              utilize the features of the App and to provide better user
              experience to Clients. Such use shall expressly include sharing
              the Personal Information with Affiliates and Lenders.
            </p>
            <p className="para_heading">4. USAGE OF GOOGLE ADVERTISING ID </p>
            <p>
              As per the terms of Google Play Services, the Company shall use
              the Google advertising ID when available on a device, only for
              advertising and user analytics purposes. The Company may share
              this ID with advertising partners only for the purpose of
              advertising. The Company shall not connect the advertising ID to
              any personally-identifiable information without the explicit
              consent of Clients. The Company shall abide by reset and “Opt out
              of Interest-based Advertising” settings of Clients.
            </p>
            <p className="para_heading">5. DATA USE AND PRIVACY </p>
            <p>
              Some functionality of the App may require the transmission of
              information provided by the User including user names and
              passwords, mobile numbers, addresses, e-mail addresses, financial
              information (such as credit card numbers) or GPS location (“User
              Information”). Please do not submit any personal information or
              data without first reading the WEALTH AVENUE Privacy Policy which
              explains WEALTH AVENUE’s data use and privacy practices in detail.
              If the User uses such App functionality, the User shall be deemed
              to have consented to the transmission of User Information to
              WEALTH AVENUE, its agents and/or service providers and authorizes
              WEALTH AVENUE, its agents and/or service providers to record,
              process and store such User Information as necessary for the App
              functionality and for purposes described in the WEALTH AVENUE
              Privacy Policy. All information which User provides in connection
              with the App, Services or these Terms shall be current, true,
              accurate, supportable and complete. User shall promptly notify
              WEALTH AVENUE in writing of any changes to such information. The
              User is solely responsible for maintenance of the confidentiality
              and security of any User Information transmitted from or stored on
              a device for purposes of the App, for all transactions and other
              activities undertaken in the User’s name, whether authorized or
              unauthorized. The User agrees to immediately notify WEALTH AVENUE
              of any unauthorized transactions associated with the App or any
              other breach of security. To the extent possible under the law,
              WEALTH AVENUE shall not be responsible for any losses arising out
              of the loss or theft of User Information transmitted from or
              stored on a device or from unauthorized or fraudulent transactions
              associated with the App As servers may be located in other
              jurisdictions your personal data and User Information may be
              transferred to, stored, used and processed in a jurisdiction other
              than India. You understand and consent to the transfer of personal
              data outside India.
            </p>
            <p className="para_heading">
              6. LAW AND DATA PROTECTION WEALTH AVENUE{" "}
            </p>
            <p>
              can share your information with government agencies regulated
              under the law, without obtaining your prior written or verbal
              consent, in order to receive information for the purpose of
              verifying identity or detection, investigation, prevention
              including prosecution, cyber incidents, punishment of offences
              etc, where disclosure is mandatory to comply with any legal
              obligations. Any information can be needed to be disclosed with
              third party by WEALTH AVENUE by any order as per the law for time
              being in force. Unsubscribe In case you are not interested to
              receive email announcements or other marketing information from
              our end, then please email your request at admin@wealthavenue.in
              It may take us about 10 days for processing your request.
            </p>
            <p className="para_heading">
              7. PURPOSE OF USER DATA COLLECTION WEALTH AVENUE{" "}
            </p>
            <p>
              will collect your information and data when you register for an
              account or use its services or products, visit the site pages or
              when you enter sweepstakes or promotions as featured on website.
              On registering with this website, you may be asked for your first
              name, last name, email address, state and city of residence,
              gender, and date of birth. You are not anonymous to
              wealthavenue.in once you register and sign at the Website. You can
              be asked for your contact number at the time of registration and
              can be send SMS notifications about the sit’s services to your
              wireless device. By registering with wealthavenue.in or Website,
              you authorize us to send you email and text alerts to you with
              your login details and other service needs, along with promotional
              SMSs or emails. Your information is used to: Administer or carry
              out obligations of the site in relation to any agreement with our
              business partners Process orders or applications submitted by you
              Respond to queries or requests submitted by you Resolve or
              anticipate problems with any Services supplied to you Send you
              details about special offers or promotions. We may inform you of
              new products or features. These might be of a third-party offers
              or products, with which our website has a tie-up or our own offers
              or products Send you , communications, alerts, notices relevant to
              your use of services or products offered on WEALTH AVENUE Improve
              the website and services provided by WEALTH AVENUE. We are
              authorized to combine details we receive from you with information
              you receive from third-parties Some features on this website or
              our services shall demand you to give personally identifiable
              information as state by you under your account section at the
              website As otherwise mentioned in this Privacy Policy
            </p>
            <p className="para_heading">
              8. SHARING OF PERSONAL INFORMATION WITH THIRD PARTIES
            </p>
            <p>
              Company shall not publish, sell, give on rent, trade or otherwise
              transfer Personal Information to third parties, except as may be
              required by law, or pursuant to the order of a court or regulatory
              authority, or in order for Company to enforce its rights, or as
              expressly stated by this Policy. In the event Company needs to
              share Personal Information with third parties, Company shall enter
              into non-disclosure agreements or equivalent covenants that are,
              at the least, as protective as the provisions of this Policy.
            </p>
            <p className="para_heading">9. CHOICE </p>
            <p>
              {" "}
              Company reasonably presumes that Clients who make available
              Personal Information to Company are doing so out of their own
              volition. Company does not compel Clients to disclose Personal
              Information. At any time, Clients may opt not to provide Personal
              Information by uninstalling the App.
            </p>
            <p className="para_heading">
              10. CORRECTNESS AND INTEGRITY OF PERSONAL INFORMATION
            </p>
            <p>
              Company accesses Personal Information as aforesaid from SMS
              messages on an ‘as is’ basis. Therefore, Company shall not be
              responsible in any way for the correctness, completeness and
              integrity of any Personal Information collected hereunder.
            </p>
            <p className="para_heading">11. SECURITY </p>
            <p>
              Company shall take all reasonable precautions by way of using
              current industry standard encryption technologies to protect
              Personal Information from loss, misuse and unauthorized access,
              disclosure, alteration and destruction.
            </p>
            <p className="para_heading">12. AUTHORISATION FOR CONTACT </p>
            <p>
              By registering and/or using Website, you give authority to WEALTH
              AVENUE and its affiliates, partners, representatives etc to: Offer
              you Services for the product you have opted for To contact you via
              email or phone call or SMS Provide product knowledge Offer
              promotional offers running on WEALTH AVENUE and offers by its
              associated third parties and business partners
            </p>
            <p className="para_heading">13. LIMIT OF LIABILITY</p>
            <p>
              Notwithstanding anything to the contrary in this Policy or any
              other terms of service or use applicable as between Company and
              Clients, Company’s aggregate liability hereunder shall be limited
              to Rs.1000/- (Rupees One Thousand Only) and shall not extend to
              any indirect or remote damages whatsoever, including but not
              limited to special, incidental, consequential, or punitive damages
              or loss of profits.
            </p>
            <p className="para_heading">14. ENFORCEMENT </p>
            <p>
              For any inquiries and complaints, the following email address may
              be used: admin@wealthavenue.in All inquiries and complaints shall
              be looked into promptly and without charging any fee to the
              inquirer / complainant.
            </p>
            <p className="para_heading">15. COMPLIANCE </p>
            <p>
              Company shall always cooperate with regulatory authorities and
              investigating agencies in India in the matter of treatment of
              Personal Information.
            </p>
            <p className="para_heading">16. AMENDMENTS </p>
            <p>
              Company may modify this Policy in its sole discretion at any time.
              While Company shall make best efforts to notify Clients of any
              such modification, it shall be Clients’ responsibility to read and
              understand the Policy as prevalent from time to time. Installation
              of the App shall be deemed to constitute acceptance of the Policy
              as amended.
            </p>
            <p className="para_heading">17. DND </p>
            <p>
              By registering your phone number on weathavenue.in, you expressly
              authorize us to override the national Do-Not-Disturb Registry
              (DND) i.e. – even if your registered phone number falls under DND
              list of National Consumer Preference Registry (NCPR/NDNC), you
              voluntarily allow us the authority to call, sms about its
              products, services and promotional offers. You also accept & agree
              to our Privacy Policy.
            </p>
            <p className="para_heading">
              18. DISCLOSURE OF INFORMATION TO THIRD PARTIES{" "}
            </p>
            <p>
              Disclosure to Successors: We may disclose your Personal
              Information to any successor-in-interest of ours, such as a
              company that acquires us. In the event WEALTH AVENUE goes through
              a business transition, such as a merger or acquisition by or with
              another company, or sale of all or a portion of our assets, we
              reserve the right to transfer or share any information we have
              about you with such entity and the use of the information thus
              shared shall be governed by the Privacy Policy of that entity. You
              will be notified via email or by a notice on our Website of any
              such change in ownership or control of your Personal Information.
              Disclosure to Third Party Service Providers and Online Partners:
              We may contract with various third parties who help us provide,
              maintain and improve the Website and WEALTH AVENUE Services. For
              example, we use a third party to process payments made to us, and
              may subcontract out production, fulfillment, analytics, reporting
              or other operations. We also contract with several online partners
              to help us manage, monitor and optimize our Website and the WEALTH
              AVENUE Services and to measure the effectiveness of our
              advertising, communications and customer/visitor behavior. We use
              commercially reasonable efforts to prevent such third parties from
              disclosing your Personal Information, except for the purpose of
              providing the services in question. We cannot guarantee that such
              third parties will not disclose your Personal Information.
              Disclosure of Non-Personal Information: We will disclose
              Non-Personal Information, in aggregate form, to potential
              strategic partners, advertisers, investors, customers, and others.
              You may not opt-out of the sharing of this information. However,
              such non-personal information cannot be easily used to identify
              you personally. Internet Advertising: We may use third party
              service providers to serve ads on our behalf across the Internet
              and sometimes on the Website. They may collect anonymous
              information about your visits to our Website, and your interaction
              with our products and services. They may also use information
              about your visits to this and other websites to target
              advertisements for goods and services. This anonymous information
              is collected through the use of a web beacon, which is industry
              standard technology used by most major websites. Disclosure to
              Credit Rating Agencies: To make an improvement in its business and
              service quality, WEALTH AVENUE may share the personal information
              of a user with Credit Rating Agencies or as may be directed by any
              government regulatory/ statutory authority.
            </p>
            <p className="para_heading">
              19. DATA COLLECTED BY THIRD PARTIES AND THIRD PARTY ADVERTISING{" "}
            </p>
            <p>
              WEALTH AVENUE may use third party service provider for serving ads
              on our behalf over the internet and perhaps on the site as well.
              They can collect anonymous information regarding your visits to
              website and interaction with our services and products. They can
              also utilize details about your visits to our website or other
              sites for targeted advertisements of services and goods. This
              anonymous data is taken from use of pixel tag that is industry
              standard technology utilized by many major websites. None
              information that is personally identifiable is used or gathered in
              this process. There may be other sites or affiliates linked to
              wealthavenue.in. Any personal details you provide to these
              websites or affiliates are not our property. Such affiliated sites
              can gave different practises for privacy, and terms and condition,
              and thus we encourage you to be updated with their privacy
              policies and other terms when you visit them. There a number of
              services and products such as loan and credit card by third
              parties on our website, like lenders, credit card issuers, banks
              and others. Such companies can utilize information (excluding
              address, email address, name and/or telephone number) regarding
              your visits to the website for offering advertisements on the site
              or other third party websites relevant to goods and services which
              may or may not interest you. If you choose to apply for products
              and/or services separately or disclose details to such providers,
              then utilization of your details is governed by their Privacy
              Policies.
            </p>
            <p className="para_heading">
              20. PROTECTION OF PERSONAL INFORMATION{" "}
            </p>
            <p>
              Personal Information: Whenever we obtain your Personal
              Information, we use security policies and procedures to protect it
              from unauthorized access or disclosure. To make sure your personal
              information is secure, we communicate our privacy and security
              guidelines to our employees and strictly enforce privacy
              safeguards within the company. However, we cannot provide any
              absolute guarantee of the security of your Personal Information.
              Accordingly, we assume no liability for any disclosure of data due
              to errors in transmission, unauthorized third party access or
              other acts of third parties, or acts or omissions beyond our
              reasonable control. Website Content: The content that you store,
              post, or transmit on or through the Website, may be accessed by
              other users, including people that you do not know. We are not
              responsible for the actions of others. Therefore, you should use
              care in communicating with other users and only disclose your
              Personal Information to other users that you know to be
              trustworthy. You are responsible for maintaining the
              confidentiality of your account information and we recommend you
              to choose your password carefully, and keep your password and
              computer secure by signing out after using our services.
            </p>
            <p className="para_heading">
              21. REVIEWING AND CHANGING YOUR PERSONAL INFORMATION
            </p>
            <p>
              You can obtain a copy of your personal information and request
              that we correct errors if any, in the same by sending us an email
              at admin@wealthavenue.in. For your protection, you will be
              required to provide proof of your identity to obtain a copy of
              your personal information. You may also opt out of receiving
              promotional communications from WEALTH AVENUE or opt-out of
              sharing your personal information with third parties by emailing
              us about the same. If your personal information changes or if you
              no longer want to use WEALTH AVENUE Services, you may correct,
              update or deactivate your personal information and/or your account
              through the account management screen. If you would like us to
              deactivate or terminate your account you can also contact us at
              admin@wealthavenue.in.. In case of cancellation or deletion of
              your account, kindly note that certain personal information may be
              retained by us, wherever required or authorized by applicable law.
              Please remember any content that has been shared by you or
              submitted to any third party link provided via the Services may
              continue to be available to third parties. Tell-A-Friend: If you
              choose to use our referral service to tell a friend about the
              Website or the WEALTH AVENUE Services, we may ask you for your
              friend’s name, phone number and email address. We will
              automatically send your friend a message inviting him or her to
              visit the Website. We store this information for the sole purpose
              of sending this message and tracking the success of our referral
              program. Internet-based Transfers Given that the Internet is a
              global environment, using the Internet to collect and process
              Personal Information necessarily involves the transmission of data
              on an international basis. By providing WEALTH AVENUE with your
              Personal Information you acknowledge and agree that we may store
              your Personal Information and transfer it to and from our servers.
              We endeavour to protect all Personal Information collected through
              the Website in a safe, confidential and secure manner.
            </p>
            <p className="para_heading">
              22. CHILDREN’S PRIVACY WEALTH AVENUE{" "}
            </p>
            <p>
              Services are intended for users ages 18 and older only.
              Accordingly, we will not knowingly collect or use any Personal
              Information from individuals that we know to be under the age of
              18. In addition, we will delete any information in our database
              that we know originates from an individual under the age of 18.
            </p>
            <p className="para_heading">23. COOKIE POLICY </p>
            <p>
              If enabled, we may place cookies on your machine that store small
              amounts of data on your computer about your visit to any of the
              pages of our Website. Cookies are small electronic files that
              collect information when someone visits a website. They can
              identify the pages that are being viewed and this can assist us in
              tracking which of our features appeal the most to you and what
              content you may have viewed on past visits. Some cookies only
              exist whilst viewers are online, but ‘persistent’ cookies are not
              session-based and remain on the viewer’s computer. When you visit
              this Website again, ‘persistent’ cookies can enable us to
              customize our content according to your preferences. Technologies
              such as: cookies, beacons, tags and scripts are used by us and our
              partners like banking and financial entities, affiliates, or
              analytics or service providers use technologies such as google Ad
              sense, google analytics etc. These technologies are used in
              analysing trends, administering the Website, tracking users’
              movements around the Website and to gather demographic information
              about our user base as a whole. We may receive reports based on
              the use of these technologies by these companies on an individual
              as well as aggregated basis. WEALTH AVENUE is not responsible for
              cookies placed in the device of user/s by any other website and
              information collected thereto.
            </p>
            <p className="para_heading">
              24. TESTIMONIALS, BLOGS AND OTHER FORUMS ON WEALTH AVENUE WEBSITE{" "}
            </p>
            <p>
              With your consent WEALTH AVENUE may post your testimonial along
              with your name. If you want your testimonial removed please
              contact WEALTH AVENUE at admin@wealthavenue.in. If you use a blog
              or other public forum on Website, any information you submit there
              can be read, collected or used by other users and could be used to
              send you unsolicited messages. WEALTH AVENUE is not responsible
              for the Personal Information you choose to submit in these forums.
            </p>
            <p className="para_heading">25. CONFIDENTIALITY </p>
            <p>
              Information Sharing and Disclosure We do not rent of sell your
              information to anyone, but only as per directions in the Privacy
              Policy. We can share the information with business partner and/or
              affiliate. WEALTH AVENUE can also sell share and/or transfer
              personally identifiable information with successors-in-interest
              given a sale of any part of the company’s business or on
              reorganization, consolidation, merger of WEALTH AVENUE to another
              entity on grounds that we are not the surviving entity. We can use
              third party service providers for providing you our services. We
              can ensure such parties to maintain confidentiality of information
              provided to them as per stated in our contracts. Access to your
              personal identifiable details and account information are
              restricted strictly and to be utilized in accordance to specific
              internal processes for operation, development or improvement of
              our services. We limit use and collection of your personal
              information, but may make aggregate or anonymous personal
              information or/and disclose these data only in manner that is
              non-personally identifiable. The data will not identify you
              individually.
            </p>
            <p className="para_heading">26. CYBER SECURITY WEALTH AVENUE </p>
            <p>
              can employ appropriate organizational or technical security
              measures at any time in order to safeguard information collected
              from you. We can use multiple electronic, physical security and
              procedural measures to protect against unlawful or unauthorized
              alteration or use of details, and against any destruction, damage,
              or accidental loss, to information. No method of electronic
              storage or transmission on the internet, however, is hundred
              percent secure. Thus, we cannot guarantee an absolute security.
              You are also responsible to maintain security and confidentiality
              of your password and login id, as we will not give these
              credentials with unrelated third parties.
            </p>
            <p className="para_heading">27. LOG FILES </p>
            <p>
              WEALTH AVENUE uses log files, in which the details can include
              browser type, internet protocol (IP), referring/exit pages,
              date/stamp, platform type, internet service provider (ISP), number
              of clicks to analyse trends, track user’s movement in aggregate,
              administer the site, and collect broad demographic data for
              aggregate use. We can do this to improve our offered services or
              improve marketing, site functionality or analytics. We may collate
              these automatically from collected log information with other
              details we collect from or about you.
            </p>
            <p className="para_heading">
              28. CHANGES IN PRIVACY POLICY WEALTH AVENUE{" "}
            </p>
            <p>
              does reserve the right to change or update its Privacy Policy or
              any other policy, terms and conditions from time to time as per
              its sole discretion. We can alter the conditions and statements to
              reflect any changes in our information practices. To stay updated,
              we encourage you to review the Privacy Policy periodically.
            </p>
            <p className="para_heading">29. HOW TO CONTACT WEALTH AVENUE </p>
            <p>
              For more information about our Privacy Policy or any comments
              related to our Services, please contact us by email at
              admin@wealthavenue.in.or write to us at: WEALTH AVENUE CONSULTANCY
              SERVICES PVT LTD, Master Associates P No -246/68 S/F School Block
              East Delhi 110092.
            </p>
            <p className="para_heading">30. GRIEVANCE OFFICER </p>
            <p>
              <b>Grievance redressal mechanism:</b> Customers who wish to
              provide feedback or raise a complaint regarding our services may
              reach us through the following channels between 10:00 am and 7:00
              pm, Monday to Friday (excluding national holidays):
            </p>
            <p>
              <b>Level 1 – Customer Support </b>
            </p>
            <p>(i) Call our Customer Service Helpline: +91 8744812065 </p>
            <p>(ii) Email us at: admin@wealthavenue.in. </p>
            <p>
              Our team will acknowledge your concern within 48 working hours and
              aim to resolve it within 7 working days.{" "}
            </p>
            <p>
              <b>Level 2 – Escalation to Grievance Redressal Officer (GRO) </b>
            </p>
            <p>
              If you are not satisfied with the resolution provided, or if your
              complaint is not resolved within 7 working days, you may escalate
              the issue to our Grievance Redressal Officer:
            </p>
            <p>
              <b>Name:</b> Mr. Nikunj Mathur
            </p>
            <p>
              <b>Email:</b> nikunj.mathur@wealthavenue.in
            </p>
            <p>
              <b>Phone:</b> +91 9958582065 (10:30 am to 6:00 pm – Monday to
              Friday, except national holidays)
            </p>
            <p>
              If you have suggestions, concerns or questions regarding our
              Privacy Policy, you can reach us using the contact information
              given above.
            </p>
          </ul>
        </div>
      </AppModalBs>
    );
  }
}

export default OpenRouteModel;
